import { emptys } from "../../../../data/main";
import { screensSearch } from "../../../../data/screensSearch";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { addSecond } from "../../../../utils/addOneSecond";
import { getCurrentTime } from "../../../../utils/getCurrentTime";

export const writePayloadReportData = async ({
  t,
  user,
  id,
  code,
  tempValues,
  schedulesList,
  setMsg,
  setModalData2,
  closeMsg,
  logoutAction,
}: stdObject) => {
  let data: stdObject = {
    serie: user.CODSUC,
    dates:
      id === "F5"
        ? []
        : [
            tempValues[id][`FEC${code}`].value,
            tempValues[id][`FEC${code}`].value2,
          ],
    staff:
      "staff" in screensSearch[id]
        ? tempValues[id][`${screensSearch[id].staff}${code}`].value
        : false,
    status:
      "status" in screensSearch[id]
        ? tempValues[id][`${screensSearch[id].status}${code}`].value
        : false,
  };
  switch (id) {
    case "D1":
      if (!emptys.includes(tempValues.D1.SCHIRE.value) || user.IRESUC) {
        if (
          [
            emptys.includes(tempValues.D1.HORIRE?.value),
            emptys.includes(tempValues.D1.HORIRE?.value2),
            emptys.includes(tempValues.D1.FEC3IRE?.value),
          ].includes(true) &&
          !user.IRESUC
        ) {
          closeMsg();
          data = { isOk: false };
        } else {
          data.time =
            user.IRESUC === 2
              ? [tempValues.D1.HORIRE.value, getCurrentTime()]
              : [tempValues.D1.HORIRE.value, tempValues.D1.HORIRE.value2];
          data.dates = [tempValues.D1.FEC3IRE.value, ""];
          if (user.IRESUC) {
            let isError = 0;
            data.shift = tempValues.D1.SCHIRE.value;
            const prevCode = schedulesList.find(
              (e: stdObject) => e.CODHOR === Number(tempValues.D1.SCHIRE.value),
            )?.PREHOR;
            if (tempValues.D1.SCHIRE.value === "") {
              isError = 3;
            } else if (typeof prevCode === "number") {
              if (prevCode > 0) {
                const responsePrevData: stdObject = await sendData({
                  endPoint: "getPrevShiftExists",
                  payload: {
                    serie: data.serie,
                    date: data.dates[0],
                    shift: prevCode,
                  },
                  logoutAction,
                });
                if (responsePrevData.success && responsePrevData.status) {
                  if (responsePrevData.prevShift) {
                    try {
                      const prevShift = JSON.parse(responsePrevData.prevShift);
                      if (prevShift.results.date === data.dates[0]) {
                        data.time[0] = addSecond(prevShift.results.hours[1]);
                      } else {
                        isError = 1;
                      }
                    } catch (error) {
                      console.log("error", error);
                      isError = 1;
                    }
                  } else {
                    isError = 1;
                  }
                }
              }
            } else {
              isError = 2;
            }
            if (isError) {
              setMsg("error");
              setModalData2({
                label:
                  isError === 3
                    ? t("p.selectAShift")
                    : isError === 2
                      ? t("p.searchShiftError")
                      : t("p.cantStartShiftPrevShift"),
              });
              data = { isOk: "msg" };
            }
          }
        }
      }
      break;
    case "D6":
      data.code =
        tempValues[id].CUEICA.value === "" ? "0" : tempValues[id].CUEICA.value;
      break;
    case "F5":
      data.search = [tempValues[id].CODBAT, tempValues[id].BATBAT];
      data.search[0].value = data.search[0].value.trim();
      data.search[1].value = data.search[1].value.trim();
      break;
    case "F10":
      data.code = [
        tempValues[id].CODINV.value.trim(),
        tempValues[id].CODINV.mode,
      ];
      data.name = [
        tempValues[id].NOMINV.value.trim(),
        tempValues[id].NOMINV.mode,
      ];
      break;
  }
  return data;
};
